<div *ngIf="data$.countries as countries">
  <div [ngClass]="customClass" *ngIf="countries[data]" class="d-flex align-items-center">
    <ng-container *ngIf="countries[data].name !== 'All Countries'; else allCountries">
      <img *ngIf="countries[data].img" src="{{ countries[data].img }}" width="20" height="20" />
      &nbsp;{{ data }}&nbsp;
      <ng-container *ngIf="length; else fullStr">
        <span class="text-color text-color--gray" p500UITooltip [tooltipData]="countries[data].name" [longContent]="true"
          >/
          {{ countries[data].name.length > length ? (countries[data].name | slice: 0:length) + '...' : countries[data].name }}
        </span>
      </ng-container>
      <ng-template #fullStr>
        <span class="text-color text-color--gray"
          >/
          {{ countries[data].name }}
        </span>
      </ng-template>
    </ng-container>
  </div>
  <div [ngClass]="customClass" *ngIf="!countries[data]">
    <gtd-ui-field-default-string-or-empty [data]="data"></gtd-ui-field-default-string-or-empty>
  </div>
</div>

<ng-template #allCountries>
  <img src="/assets/new-img/flags/all.svg" width="32" height="16" class="mr-8" />
  <span class="text-color text-color--gray">All Countries</span>
</ng-template>
